import { render, staticRenderFns } from "./TgNewWorkList.vue?vue&type=template&id=d62e3b60&"
import script from "./TgNewWorkList.vue?vue&type=script&lang=js&"
export * from "./TgNewWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports